import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Edit from '@material-ui/icons/Edit';
import Save from '@material-ui/icons/Save';
import { MultiSelectField } from 'components/Form';
import { ProfileContext } from 'utils/context';

const ValueList = ({ items, title }) => (
  <div className="mb-6">
    <p className="text-sm text-boulder uppercase mb-2">{title}</p>
    {items.length > 0 ? (
      <div className="flex flex-wrap">
        {items.map(({ label, value }) => (
          <span
            className="bg-gradient-easter-bostonBlue px-2 py-1 mr-2 mb-2 rounded text-white shadow"
            key={value}
          >
            {label}
          </span>
        ))}
      </div>
    ) : (
      <p className="text-dusty">Not provided</p>
    )}
  </div>
);

ValueList.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

const InterestsAndEvents = ({
  classificationOptions,
  isLoadingClassifications,
}) => {
  const { isView, readOnly } = useContext(ProfileContext);
  const { handleSubmit, values } = useFormikContext();
  const [viewProfile, toggleForm] = useState(isView);
  const musicGenres = values.music_genres || [];
  const eventTypes = values.event_types || [];
  const eventFormats = values.event_formats || [];
  const eventAttendLocations = values.event_attend_locations || [];

  if (viewProfile || readOnly) {
    return (
      <div>
        <div className="flex justify-between">
          <h4 className="text-dusty text-lg font-semibold uppercase mb-4">
            Interests &amp; Events
          </h4>
          {!readOnly && (
            <Edit
              className="text-dusty cursor-pointer hover:text-easter"
              onClick={() => toggleForm(false)}
              role="presentation"
            />
          )}
        </div>
        <ValueList
          title="Content topics I am interested in"
          items={musicGenres}
        />
        <ValueList title="Event types" items={eventTypes} />
        <ValueList title="Preferred event formats" items={eventFormats} />
        <ValueList
          title="Where I would attend events"
          items={eventAttendLocations}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="sm:flex justify-between mb-8 sm:mb-0">
        <h5 className="text-lg mb-4">Interests &amp; Events</h5>
        {isView && (
          <button
            className="flex text-dusty hover:text-easter justify-end focus:outline-none"
            type="button"
            onClick={() => {
              handleSubmit();
              toggleForm(true);
            }}
          >
            <Save />
            <span className="ml-2">Save Changes</span>
          </button>
        )}
      </div>
      <MultiSelectField
        name="music_genres"
        label="Content topics you are interested in"
        options={classificationOptions.music_genres}
        placeholder="Select content topics"
        creatable={false}
        isLoading={isLoadingClassifications}
      />
      <MultiSelectField
        name="event_types"
        label="Event types you are interested in (up to 3)"
        max={3}
        options={classificationOptions.event_types}
        placeholder="Select event types"
        creatable={false}
        isLoading={isLoadingClassifications}
      />
      <MultiSelectField
        name="event_formats"
        label="Preferred event formats"
        options={classificationOptions.event_formats}
        placeholder="Select event formats"
        creatable={false}
        isLoading={isLoadingClassifications}
      />
      <MultiSelectField
        name="event_attend_locations"
        label="Where would you attend events?"
        options={classificationOptions.event_attend_locations}
        placeholder="Select event regions"
        creatable={false}
        isLoading={isLoadingClassifications}
      />
    </div>
  );
};

InterestsAndEvents.propTypes = {
  classificationOptions: PropTypes.object.isRequired,
  isLoadingClassifications: PropTypes.bool,
};

InterestsAndEvents.defaultProps = {
  isLoadingClassifications: false,
};

export default InterestsAndEvents;
